import { useIntl } from 'react-intl';
import { forwardRef } from '@chakra-ui/react';

import { Table } from '../../Table';
import { type RowProps } from '../../Table/parts';
import { useFees } from '../context';

export type SepaTransferProps = RowProps;

export const SepaTransfer = forwardRef<SepaTransferProps, 'div'>(
  (props, ref) => {
    const intl = useIntl();
    const { fees, quotas, toFixed, toVariable } = useFees();

    const locales = {
      label: intl.formatMessage({
        id: 'subscription.fees_modal.sepa_transfer.label',
      }),
      value: intl.formatMessage(
        {
          id: 'subscription.fees_modal.sepa_transfer.value',
        },
        {
          fixed: toFixed(fees.additionalSepaTransfer),
          limit: quotas.sepaTransferMonthQuota.limit,
          variable: toVariable(fees.additionalSepaTransfer),
        },
      ),
    };

    return (
      <Table.Row {...props} ref={ref}>
        <Table.CellText>{locales.label}</Table.CellText>
        <Table.CellAmount>{locales.value}</Table.CellAmount>
      </Table.Row>
    );
  },
);
